import styled from 'styled-components';
import { getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
export const Container = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => getBackgroundColor('lighter')(props)};
  border-bottom: 1px solid ${props => getBackgroundColor('darker')(props)};
  border-top: 1px solid ${props => getBackgroundColor('darker')(props)};
  padding: 14px 16px;
`;
export const Content = styled.div``;
export const Title = styled(Text)``;
export const FilterSelected = styled(Text)`
  margin: 4px 0;
  color: ${props => getTextColor('scratched')(props)};
`;
export const FilterDetailTitleContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => getBackgroundColor('darker')(props)};
  margin-bottom: 0.5em;
`;
export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;